import React, { useState } from 'react';
import { Row, Col, Form } from 'antd';
import moment, { Moment } from 'moment';
import { CalendarOutlined } from '@ant-design/icons';
import type { FormFieldProps } from './types';
import * as S from './styles';

const { useWatch } = Form;

interface DueDateDropdownProps extends FormFieldProps {
	limitDate?: Date | Moment;
}

export function DueDateDropdown({ formName = [''], isRequired = false, limitDate }: Readonly<DueDateDropdownProps>) {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const fieldName = [...formName, 'due_date'];
	const dueDate = useWatch(fieldName);

	function handleToggleDatePicker(): void {
		setIsOpen((prevState) => !prevState);
	}

	function isDisabledDate(currentDate: Moment): boolean {
		if (!currentDate) return false;

		const isToday = moment().startOf('day');
		const maxDate = limitDate ? moment(limitDate).endOf('day') : null;

		const isPast = currentDate < isToday;
		const isAfterLimit = maxDate ? currentDate > maxDate : false;

		return isPast || isAfterLimit;
	}

	return (
		<Row>
			<Col>
				<S.IconButton $isSelected={!!dueDate} onClick={handleToggleDatePicker}>
					<CalendarOutlined />
				</S.IconButton>
			</Col>
			<Col>
				<S.CustomFormItem required={isRequired} name={fieldName}>
					<S.InvisibleDatePicker
						open={isOpen}
						placement="bottomRight"
						disabledDate={isDisabledDate}
						onOpenChange={handleToggleDatePicker}
					/>
				</S.CustomFormItem>
			</Col>
		</Row>
	);
}
